<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li>
                                <a href="/" title="Home">Home</a>
                            </li>
                            <li>Ação Comercial</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase">
                            <b>Ação Comercial</b>
                        </h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label for="acaoComercialExternalHash">Ação Comercial Box (Hash)</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="acaoComercialExternalHash"
                                        placeholder="Ação Comercial Box (Hash)"
                                        v-model="filter.acaoComercialExternalHash"
                                    />
                                </div>
                                
                                <div class="form-group col-md-3">
                                    <label for="statusAcaoComercialId">Status Ação Comercial</label>
                                    <select class="form-control" id="statusAcaoComercial">
                                        <option value="0">Todos</option>
                                        <option value="1">Planejada</option>
                                        <option value="2">Realizada</option>
                                        <option value="3">Cancelada</option>
                                    </select>
                                </div>
                            </div>
                            <button
                                type="button"
                                class="btn-large-40 btn-red uppercase"
                                @click="executeFilter(filter)"
                            >Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Hash Box</th>
                                    <th>
                                        Descricao
                                        <i @click="executeOrderBy('Descricao')" class="fa fa-sort"></i>
                                    </th>
                                    <th>#</th>
                                    <th class="text-center" width="150">
                                        <i class="fa fa-cog"></i>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in result.items"
                                    v-bind:key="item.acaoComercialId"
                                    class="animated fadeIn"
                                >
                                    <td>{{ item.acaoComercialId }}</td>
                                    <td>{{ item.acaoComercialExternalHash }}</td>
                                    <td>{{ item.descricao }}</td>
                                    <td>{{ item.statusAcaoComercialId }}</td>

                                    <td class="text-center">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-danger"
                                            @click="openEdit({ acaoComercialId: item.acaoComercialId })"
                                            title="Detalhes"
                                        >
                                            <i class="fa fa-list"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination
                            :total="result.total"
                            :page-size="filter.pageSize"
                            :callback="executePageChanged"
                        ></pagination>
                    </div>
                </div>
            </div>
        </section>

        <b-modal
            :no-close-on-backdrop="true"
            size="lg"
            :no-close-on-esc="true"
            centered
            v-model="dialogCreate"
            :hide-footer="true"
            title="Criar"
        >
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal
            :no-close-on-backdrop="true"
            size="xl"
            :no-close-on-esc="true"
            centered
            v-model="dialogEdit"
            :hide-footer="true"
            title="Detalhes Ação Comercial"
        >
            <form-acao-cadastro
                v-if="dialogEdit"
                :id="acaoComercialId"
                @on-saved="onSaved()"
                @on-back="hideAll()"
            />
        </b-modal>

        <b-modal
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            centered
            v-model="dialogRemove"
            title="Confirmação"
        >
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">Remover</button>
            </div>
        </b-modal>
    </main>
</template>
<script>

import base from '@/common/base.js'
import { Api } from '@/common/api'

import formCreate from './form-create'
import FormAcaoCadastro from './form-acao-cadastro.vue'

export default {
    name: 'acaoComercial',
    mixins: [base],
    components: { formCreate, FormAcaoCadastro },
    data() {
        return {

            resources: {
                filter: 'acaocomercial',
                remove: 'acaocomercial'
            },

            dialogRemove: false,
            dialogCreate: false,
            dialogEdit: false,

            model: {},
            filter: {
                pageSize: 50,
                pageIndex: 1,
                isPagination: true,
            },

            result: {
                total: 0,
                items: []
            }
        }
    },
    methods: {
        openEdit: function (model) {
            this.acaoComercialId = model.acaoComercialId;
            this.dialogEdit = true;
        },
        openCreate: function () {
            this.dialogCreate = true;
        },
        onSaved: function () {
            this.hideAll();
            this.executeLoad();
        },
        hideAll: function () {
            this.dialogCreate = false;
            this.dialogEdit = false;
            this.dialogRemove = false;
        },

        openRemove: function (model) {
            this.dialogRemove = true;
            this.model = model;
        },
        executeRemove: function (model) {
            if (model) this.model = model;
            new Api(this.resources.remove).delete(this.model).then(() => {
                this.defaultSuccessResult("Item removido com sucesso");
                this.hideAll();
                this.executeLoad();
            }, err => {
                this.defaultErrorResult(err);
            })
        },

        executeFilter: function (filter) {
            if (filter) this.filter = filter;
            this.executeLoad();
        },
        executePageChanged: function (index) {
            this.filter = this.defaultPageChanged(this.filter, index);
            this.executeLoad();
        },
        executeOrderBy: function (field) {
            this.filter = this.defaultOrderBy(this.filter, field);
            this.executeLoad();
        },
        executeLoad: function () {
            this.showLoading();
            new Api(this.resources.filter).get(this.filter).then(data => {
                if (data.summary) this.result.total = data.summary.total;
                this.result.items = data.dataList;
                this.hideLoading();
            }, (err) => {
                this.failLoading();
                if (err && err.data && err.data.errors) {
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors[0]
                    })
                }
            });
        },

    },

    mounted() {
        this.executeFilter();
    }

};
</script>